import React from 'react'

export default function Get() {
  return (
    <div>
      
    <div id="hero" className="d-flex align-items-center">
    <div className="container position-relative" data-aos="fade-up" data-aos-delay="500">
      <h1>Welcome to Insurance Advisors</h1>
      {/* <h2>We are team of talented advisors who provide best insurance services</h2> */}
      <h2>We are a team of dedicated Insurance Advisors,where protection meets precision.</h2>

      <a href="#about" className="btn-get-started scrollto">Get Started</a>
    </div>
  </div>

    </div>
  )
}
